/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatSize: {
  name: 'format-size';
  data: string;
} = {
  name: 'format-size',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"/></svg>`
};
